import TopBar from "@/components/TopBar";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import WhyChooseUs from "@/components/WhyChooseUs";

import ReviewWidget from "@/components/ReviewWidget";
import ServiceAreas from "@/components/ServiceAreas";
import FAQSection, { faqs } from "@/components/FAQSection";
import Footer from "@/components/Footer";
import { usePageMeta } from "@/hooks/use-page-meta";
import { useJsonLd } from "@/hooks/use-json-ld";

const SITE_URL = "https://jrprocleaningservice.com";

const Index = () => {
  usePageMeta({
    title: "JR Pro Cleaning Services | House & Commercial Cleaning Tampa",
    description:
      "Professional house, deep & commercial cleaning across Tampa Bay. Mon–Sat 8 AM–6 PM; Sunday closed. Free estimates: (978) 564-5018.",
    path: "/",
  });

  useJsonLd("home", [
    {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "@id": `${SITE_URL}/#business`,
      name: "JR Pro Cleaning Services",
      image: `${SITE_URL}/images/logo.png`,
      url: SITE_URL,
      telephone: "+1-978-564-5018",
      priceRange: "$$",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Tampa",
        addressRegion: "FL",
        addressCountry: "US",
      },
      areaServed: [
        "Tampa, FL",
        "Clearwater, FL",
        "St. Petersburg, FL",
        "Brandon, FL",
        "Riverview, FL",
        "Wesley Chapel, FL",
        "Lutz, FL",
        "Oldsmar, FL",
        "Carrollwood, FL",
        "Temple Terrace, FL",
        "Valrico, FL",
        "Plant City, FL",
        "Land O' Lakes, FL",
        "Palm Harbor, FL",
      ],
      openingHoursSpecification: [
        {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ],
          opens: "08:00",
          closes: "18:00",
        },
        {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: "Sunday",
          opens: "00:00",
          closes: "00:00",
        },
      ],
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ]);

  return (
    <div className="min-h-screen bg-background">
      <TopBar />
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <WhyChooseUs />
        
        <ReviewWidget />
        <ServiceAreas />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
